import CustomUndoBtn from 'components/tool/Editor/ButtonDiv/UndoButton';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { undoRoofToolLines } from 'store/slices/RoofToolLinesSlice';
import { undoEditFacetState } from 'store/slices/ToolSlice';

export default function UndoButton() {
	const dispatch = useDispatch();
	const { activeRoofTool, currentIndex: roofLinesIndex } = useSelector((state: RootState) => state.roofToolLines.data);
	const disableUndoBtn = (!activeRoofTool) || (roofLinesIndex < 1);
	const handleClick = () => {
		if(activeRoofTool) {
			dispatch(undoRoofToolLines());
		} else {
			dispatch(undoEditFacetState());
		}
	};

	return (
		<CustomUndoBtn
			id="edge-undo"
			disabled={disableUndoBtn}
			onClick={handleClick}
		/>
	);

}